export function intranetProfileInfo() {
    const $profiles = jQuery('.js-intranet-profile');

    if (!$profiles.length) {
        return;
    }

    function updateProfileLinks(initials) {
        $profiles.each(function () {
            const profileUrl = jQuery(this).data('profile-url');

            if (!profileUrl || !initials) {
                return;
            }

            jQuery(this)
                .find('.navbar-profile_link')
                .attr('href', profileUrl + '?initials=' + initials);
        });
    }

    function updateProfileMarkup(user) {
        jQuery('.profile-name').html(user.name);
        jQuery('.profil-image').attr('src', user.image);
        updateProfileLinks(user.initials);
    }

    jQuery(function () {
        const loggedUser = Cookies.get('INTRANET-LoggedInUser');

        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            updateProfileMarkup(user);
            return;
        }

        const initials = Cookies.get('INTRANET-initials');

        if (initials) {
            getLoggedInUserInfo(initials);
        }
    });

    function getLoggedInUserInfo(initials) {
        jQuery.ajax({
            type: 'GET',
            url: '/api/LdapUser/GetUserByInitials',
            dataType: 'json',
            contentType: 'application/json',
            data: {
                initials: initials,
                rootid: jQuery('body').data('id')
            },
            success: function (response) {
                const user = {
                    initials: response.userAlias,
                    name: response.firstName + ' ' + response.lastName[0] + '.',
                    image: response.profileImage,
                    created: response.created,
                    userId: response.userId
                };

                updateProfileMarkup(user);

                const date = new Date();
                date.setHours(date.getHours() + 5);

                Cookies.set('INTRANET-LoggedInUser', JSON.stringify(user), {
                    expires: date
                });
            },
            error: function () {
                console.log('Whoops something went wrong! update profile');
            }
        });
    }
}

export default intranetProfileInfo;